import { useBlockMetadata } from './useBlockMetadata';
import { useFieldMetadata } from './useFieldMetadata';

export function useBlockOrFieldReadOnly(id: string): boolean {
  const blockMetadata = useBlockMetadata(id);
  const fieldMetadata = useFieldMetadata(id);
  return (blockMetadata ?? fieldMetadata)?.isReadOnly ?? false;
}
